const production = {
  "uriAPI" : "https://cms-gp.azurewebsites.net/api",
}

export default production;